/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { FileTemplateTypeDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
/**
 * FilesTemplatesRestApi - axios parameter creator
 * @export
 */
export const FilesTemplatesRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get file template
         * @param {FileTemplateTypeDto} fileTemplateType 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileTemplate: async (fileTemplateType: FileTemplateTypeDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileTemplateType' is not null or undefined
            assertParamExists('getFileTemplate', 'fileTemplateType', fileTemplateType)
            const localVarPath = `/api/v1/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fileTemplateType !== undefined) {
                localVarQueryParameter['fileTemplateType'] = fileTemplateType;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesTemplatesRestApi - functional programming interface
 * @export
 */
export const FilesTemplatesRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilesTemplatesRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get file template
         * @param {FileTemplateTypeDto} fileTemplateType 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileTemplate(fileTemplateType: FileTemplateTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileTemplate(fileTemplateType, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesTemplatesRestApi.getFileTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FilesTemplatesRestApi - factory interface
 * @export
 */
export const FilesTemplatesRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilesTemplatesRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Get file template
         * @param {FileTemplateTypeDto} fileTemplateType 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileTemplate(fileTemplateType: FileTemplateTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getFileTemplate(fileTemplateType, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FilesTemplatesRestApi - interface
 * @export
 * @interface FilesTemplatesRestApi
 */
export interface FilesTemplatesRestApiInterface {
    /**
     * 
     * @summary Get file template
     * @param {FileTemplateTypeDto} fileTemplateType 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesTemplatesRestApiInterface
     */
    getFileTemplate(fileTemplateType: FileTemplateTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<File>;

}

/**
 * FilesTemplatesRestApi - object-oriented interface
 * @export
 * @class FilesTemplatesRestApi
 * @extends {BaseAPI}
 */
export class FilesTemplatesRestApi extends BaseAPI implements FilesTemplatesRestApiInterface {
    /**
     * 
     * @summary Get file template
     * @param {FileTemplateTypeDto} fileTemplateType 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesTemplatesRestApi
     */
    public getFileTemplate(fileTemplateType: FileTemplateTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return FilesTemplatesRestApiFp(this.configuration).getFileTemplate(fileTemplateType, lang, options).then((request) => request(this.axios, this.basePath));
    }
}

